import { render, staticRenderFns } from "./UnitInformation.vue?vue&type=template&id=af36de60&scoped=true&lang=pug&"
import script from "./UnitInformation.vue?vue&type=script&lang=ts&"
export * from "./UnitInformation.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInformation.vue?vue&type=style&index=0&id=af36de60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af36de60",
  null
  
)

export default component.exports